module.exports = __webpack_public_path__ + "static/media/pearl.e2ee74e5.jpg";